import { API_BASES } from "../../config/apiConfig";

var V = API_BASES.VENDORPAY;
export var VENDOR_TOKEN_KEY = "parkadda_vendor_token";

function getToken() {
  return typeof window !== "undefined"
    ? window.localStorage.getItem(VENDOR_TOKEN_KEY)
    : null;
}

export function setVendorToken(token) {
  if (typeof window === "undefined") return;
  if (token) window.localStorage.setItem(VENDOR_TOKEN_KEY, token);
  else window.localStorage.removeItem(VENDOR_TOKEN_KEY);
}

async function parseResponse(response) {
  var raw;
  try { raw = await response.json(); } catch (_) { raw = null; }
  if (response.status === 401) {
    setVendorToken(null);
    var err = new Error((raw && raw.message) || "Session expired");
    err.status = 401;
    throw err;
  }
  if (!response.ok || (raw && raw.success === false)) {
    var msg = (raw && raw.message) || "Request failed";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return raw && raw.payload;
}

function buildQuery(params) {
  if (!params) return "";
  var parts = [];
  Object.keys(params).forEach(function (k) {
    var v = params[k];
    if (v === undefined || v === null || v === "") return;
    parts.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
  });
  return parts.length ? "?" + parts.join("&") : "";
}

async function vpFetch(path, options) {
  var token = getToken();
  var headers = Object.assign(
    { "Content-Type": "application/json" },
    (options && options.headers) || {}
  );
  if (token) headers.Authorization = "Bearer " + token;
  var res = await fetch(V + path, Object.assign({}, options || {}, { headers }));
  return parseResponse(res);
}

export var vendorPortalApi = {
  login: function (mobile, password) {
    return fetch(V + "/portal/login/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mobile: mobile, password: password })
    }).then(parseResponse);
  },
  logout: function () {
    return vpFetch("/portal/logout/", { method: "POST", body: "{}" });
  },
  session: function () {
    return vpFetch("/portal/session/");
  },
  get: function (path, params) {
    return vpFetch(path + buildQuery(params), { method: "GET" });
  },
  post: function (path, body) {
    return vpFetch(path, { method: "POST", body: JSON.stringify(body || {}) });
  },
  listStock: function (params) {
    return vpFetch("/stock/" + buildQuery(params), { method: "GET" });
  },
  adjustStock: function (body) {
    return vpFetch("/stock/adjust/", { method: "POST", body: JSON.stringify(body) });
  },
  loadStock: function (body) {
    return vpFetch("/stock/load/", { method: "POST", body: JSON.stringify(body) });
  },
  listOrders: function (params) {
    return vpFetch("/orders/" + buildQuery(params), { method: "GET" });
  },
  getOrder: function (ref) {
    return vpFetch("/orders/" + encodeURIComponent(ref) + "/", { method: "GET" });
  },
  dashboardVendor: function (params) {
    return vpFetch("/dashboard/vendor/" + buildQuery(params), { method: "GET" });
  },
  verifyOrder: function (body) {
    return vpFetch("/orders/verify/", { method: "POST", body: JSON.stringify(body) });
  },
  fulfillOrder: function (body) {
    return vpFetch("/orders/fulfill/", { method: "POST", body: JSON.stringify(body) });
  },
  notifyOrder: function (body) {
    return vpFetch("/orders/notify/", { method: "POST", body: JSON.stringify(body) });
  }
};

export function eInvoicePageUrl(ref) {
  var base = process.env.REACT_APP_API_ROOT || "https://server.parkadda.com";
  return base.replace(/\/+$/, "") + "/api/vendorpay/e-invoice/" + encodeURIComponent(ref) + "/";
}
